import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Card, CardMedia, CardContent, Grid, Link } from '@mui/material';

interface BannerItem {
  key: string;
  imageUrl: string;
  internalDestination: boolean;
  destination: string;
}

interface BannerGalleryProps {
  title?: string;
  banners: BannerItem[];
}

/** */
const BannerGallery: React.FC<BannerGalleryProps> = ({ title, banners }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ p: 1 }}>
      {title && banners.length > 0 && (
        <Typography variant='h6' fontWeight='bold' gutterBottom>
          {title}
        </Typography>
      )}
      <Grid container spacing={2}>
        {banners.map((banner) => (
          <Grid item xs={12} sm={6} md={4} key={banner.key}>
            <Card elevation={3}>
              <CardMedia
                component='img'
                height='auto'
                image={banner.imageUrl}
                alt={banner.key}
                sx={{ objectFit: 'cover' }}
              />
              <CardContent sx={{ padding: '16px !important' }}>
                <Typography fontWeight='bold'>{banner.key}</Typography>
                {banner.destination && (
                  <Link
                    href={banner.destination}
                    target={banner.internalDestination ? '_self' : '_blank'}
                    rel='noopener noreferrer'
                    underline='hover'
                  >
                    {t('EMPLOYEES:DETAIL:LINK')}
                  </Link>
                )}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default BannerGallery;
